import React from "react";
import { X, Lock } from "lucide-react";
import PlanCards from "@/components/PlanCards";
import { unlockLine } from "@/lib/access";

export default function PaywallModal({ open, feature, onClose }) {
  if (!open) return null;
  const line = unlockLine(feature);
  return (
    <div className="fixed inset-0 z-[75] flex items-start justify-center p-4 overflow-y-auto" style={{ background: "rgba(17,17,17,0.78)" }} data-testid="paywall-modal">
      <div className="relative w-full max-w-5xl my-8 border-2 border-[#111] bg-[#F4F3EC] p-6 md:p-8" role="dialog" aria-modal="true">
        <button type="button" onClick={onClose} data-testid="paywall-close" aria-label="Close" className="absolute top-3 right-3 p-1 hover:bg-[#111] hover:text-white transition-colors">
          <X size={16} strokeWidth={2.6} />
        </button>
        <div className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] uppercase text-[#555] font-bold">
          <Lock size={12} strokeWidth={2.6} /> Locked
        </div>
        <h2 className="mt-2 font-display text-3xl md:text-4xl font-extrabold text-[#111] leading-tight" data-testid="paywall-unlock-line">
          {line || "Unlock insights from $1.99/mo"}
        </h2>
        <p className="mt-2 mb-8 text-sm text-[#555]">Pick a plan — it unlocks instantly on the website and the iPhone app.</p>
        <PlanCards prefix="paywall" />
      </div>
    </div>
  );
}
